import React from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import moment from 'moment'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'

import { CloseButton } from '../SettingsMenu.jsx'
import { fontSizeResponsive, mediaQ } from '../../../../theme/mixins'
import { deleteUser } from '../../../../../Api/backendApi'

const DropdownModalContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 10px 20px;
`
const DropdownModalRow = styled.div`
  display: flex;
  flex-direction: row;
`
const DropdownModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  padding: 20px 0;

  ${fontSizeResponsive(40)};
`
const DropdownModalRowText = styled.span`
  font-family: 'Open Sans';
  font-stretch: condensed;
  ${fontSizeResponsive(20)};
  margin: 8px 0;

  ${mediaQ('mobileAll', 'margin: 1px 0;')}

  &:before {
    content: '|';
    ${fontSizeResponsive(24)};
  }

  span {
    font-weight: bold;
    margin-left: 5px;
    ${fontSizeResponsive(22)};
  }
`

const DropdownModalSubHeader = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  ${fontSizeResponsive(24)};
  margin-bottom: 20px;

  span {
    font-weight: bold;
    ${fontSizeResponsive(28)};
    color: rgba(158, 13, 254, 1);
    margin-left: 5px;
  }
`

const DropdownModalSecondHaeder = styled.div`
  width: 50%;
  margin-left: 35%;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:100%; margin-left: 0;text-align: center;')}
`
const DiagnosticDataContainer = styled.div`
  margin: 15px 0px;
  background-color: rgba(0, 0, 0, 0.036);
  border: 1px solid rgba(0, 0, 0, 0.036);
  width: 50%;
  align-self: center;
  border-radius: 7px;
  padding: 5px 10px;
  box-shadow: 0 2.5px 1.4px -26px rgba(0, 0, 0, 0.011),
    0 6.1px 3.3px -26px rgba(0, 0, 0, 0.016),
    0 11.4px 6.3px -26px rgba(0, 0, 0, 0.02),
    0 20.3px 11.2px -26px rgba(0, 0, 0, 0.024),
    0 38px 20.9px -26px rgba(0, 0, 0, 0.029),
    0 91px 50px -26px rgba(0, 0, 0, 0.04);

  ${mediaQ('mobileAll', 'width:100%;')}
`

const DropdownModalCopyButton = styled.button`
  width: 45%;
  align-self: center;
  padding: 10px 30px;
  border: none;
  outline: none;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  transition: ease-in-out 0.35s all;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:80%;')}

  &:hover {
    transform: scale(1.025);
    border: none;
  }
`

const DropdownModalButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const AcceptDeleteButton = styled.button`
  background-color: rgb(187, 33, 36);
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: white;
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 2.8px 2.2px,
    rgba(0, 0, 0, 0.027) 0px 6.7px 5.3px, rgba(0, 0, 0, 0.035) 0px 12.5px 10px,
    rgba(0, 0, 0, 0.043) 0px 22.3px 17.9px,
    rgba(0, 0, 0, 0.05) 0px 41.8px 33.4px, rgba(0, 0, 0, 0.07) 0px 100px 80px;
  margin: 10px 15px;
  cursor: pointer;
`
export const CancelDeleteButton = styled.button`
  background-color: rgba(0, 0, 0, 0.05);
  opacity: 0.6;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.8);
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const DropdownModal = ({ modalIsOpen, closeModal, logout }) => {
  const customStyles = {
    overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0.5)` },
    content: {
      right: `unset`,
      bottom: `unset`,
      top: `${isMobile ? '5%' : '50%'}`,
      left: `${isMobile ? 'unset' : '50%'}`,
      transform: `${isMobile ? 'translate(0%, 0%);' : 'translate(-50%, -50%)'}`,
    },
  }

  const [approvalModalIsOpen, setApprovalModalIsOpen] = React.useState(false)
  const openApprovalModal = () => {
    setApprovalModalIsOpen(true)
  }
  const closeApprovalModal = () => {
    setApprovalModalIsOpen(false)
    closeModal()
  }

  const handleDeleteButton = async () => {
    const isUserDeleted = await deleteUser()

    if (isUserDeleted) {
      setTimeout(() => {
        logout()
      }, 1500)
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      // afterOpenModal={afterOpenModal}
    >
      <DropdownModalContainer className="DropdownModal">
        <CloseButton onClick={closeModal} modal />
        <DropdownModalHeader>Usuń konto</DropdownModalHeader>
        <DropdownModalSubHeader>
          Czy na pewno chcesz usunąć konto z aplikacji Miazga by FMW? Operacja
          ta jest nieodwracalna.
        </DropdownModalSubHeader>
        <DropdownModalButtonContainer>
          <CancelDeleteButton onClick={closeModal}>Anuluj</CancelDeleteButton>
          <AcceptDeleteButton onClick={openApprovalModal}>
            {' '}
            Usuń
          </AcceptDeleteButton>
        </DropdownModalButtonContainer>
        <Modal
          isOpen={approvalModalIsOpen}
          // onAfterOpen={afterOpenModal}
          onRequestClose={closeApprovalModal}
          style={customStyles}
          // afterOpenModal={afterOpenModal}
        >
          <DropdownModalContainer className="DropdownModal">
            <DropdownModalHeader>
              Potwierdzam usunięcie konta
            </DropdownModalHeader>
            <CloseButton onClick={closeApprovalModal} modal />
            <DropdownModalButtonContainer>
              <CancelDeleteButton onClick={closeApprovalModal}>
                Anuluj
              </CancelDeleteButton>
              <AcceptDeleteButton onClick={handleDeleteButton}>
                TRWALE USUŃ KONTO
              </AcceptDeleteButton>
            </DropdownModalButtonContainer>
          </DropdownModalContainer>
        </Modal>
      </DropdownModalContainer>
    </Modal>
  )
}
export default DropdownModal
